const REGEX = /(.*?)[?|#]/;

function ensureTrailingSlash(url) {
  const parts = REGEX.exec(url);
  let path = url;
  let qs = '';
  if (parts) {
    path = parts[1];
    qs = url.replace(path, '');
  }
  if (!path.endsWith('/')) {
    return `${path}/${qs}`;
  }
  return path + qs;
}

const DOMAIN = 'paperform.co';

function isLocal(url) {
  return (
    url &&
    (url.startsWith('/') ||
      url.includes(`https://${DOMAIN}`) ||
      url.includes(`http://${DOMAIN}`))
  );
}

function ensureTrailingSlashLocal(url) {
  if (isLocal(url)) {
    return ensureTrailingSlash(url);
  }
  return url;
}

module.exports = {
  default: ensureTrailingSlash,
  ensureTrailingSlash,
  ensureTrailingSlashLocal,
  isLocal,
};
